import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { makeReduxLeftWaitingRoom } from '~/main/factories/usecases/waitingRoom/LeftWaitingRoomFactory';
import { iStore } from '~/domain/interfaces/models/Store';
import { ownProps, externalProps } from '../index';

interface iStateParams {
  appointmentId: number;
}

export function ConnectComponent<P>(
  Component: ComponentType<P & ownProps>,
): React.FC<P & externalProps> {
  const Render: React.FC<P & externalProps> = ({ ...rest }) => {
    const user = useSelector((store: iStore) => store.auth);
    const { appointmentId } = useLocation<iStateParams>().state;
    const { rooms, data } = useSelector((store: iStore) => store.waitingroom);

    Component.defaultProps = {
      ActionRoom: makeReduxLeftWaitingRoom(),
      notification: data,
      waitingRoom: { room: rooms[appointmentId] },
      user,
      ...(rest as P),
    } as any;

    return <Component {...(rest as P & ownProps & externalProps)} />;
  };

  return Render;
}
